import { UI_KEYS } from '../../common/uiKeys';

export const HOME_TOUR_SEEN_STORAGE_KEY = 'rfi.homeTour.seen.v1';

export function hasSeenHomeTour(): boolean {
  try {
    return window.sessionStorage.getItem(HOME_TOUR_SEEN_STORAGE_KEY) === '1';
  } catch {
    return true;
  }
}

export function markHomeTourSeen(): boolean {
  try {
    window.sessionStorage.setItem(HOME_TOUR_SEEN_STORAGE_KEY, '1');
    return true;
  } catch {
    return false;
  }
}

// Matches AppBody's sidebar width transition so Coachmark measures the settled, collapsed sidebar rect.
export const SIDE_NAV_COLLAPSE_SETTLE_MS = 220;
export const HOME_TOUR_DOWNLOAD_HEADER_SELECTOR =
  '.abyss-data-table-header-col-8:not([data-visually-hidden])';

export const HOME_TOUR_TARGETS = {
  sidebar: `[data-tour="${UI_KEYS.HOME.DOM.TOUR_SIDEBAR}"]`,
  search: `[data-tour="${UI_KEYS.HOME.DOM.TOUR_SEARCH}"]`,
  searchButton: `[data-tour="${UI_KEYS.HOME.DOM.TOUR_SEARCH_BUTTON}"]`,
  filter: `[data-tour="${UI_KEYS.HOME.DOM.TOUR_FILTER}"]`,
  results: `tr:has([data-tour="${UI_KEYS.HOME.DOM.TOUR_FIRST_RESULT_ROW}"])`,
  pagination: `[data-tour="${UI_KEYS.HOME.DOM.TOUR_PAGINATION}"] .abyss-data-table-pagination-root`,
  download: `[data-tour="${UI_KEYS.HOME.DOM.TOUR_DOWNLOAD}"]`,
} as const;

export const HOME_TOUR_BASE_STEPS = [
  {
    target: HOME_TOUR_TARGETS.search,
    title: 'Search key',
    description: 'Search for a customer, employer group, or policy in the search field.',
  },
  {
    target: HOME_TOUR_TARGETS.searchButton,
    title: 'Search',
    description: 'Click Search or press Enter to trigger the search',
  },
] as const;

export const HOME_TOUR_SIDEBAR_STEP = {
  target: HOME_TOUR_TARGETS.sidebar,
  title: 'Sidebar navigation',
  description: 'Hover on the sidebar to view the navigation options.',
} as const;

export const HOME_TOUR_RESULT_STEPS = [
  {
    target: HOME_TOUR_TARGETS.filter,
    title: 'Quick filter',
    description: 'Narrow the loaded Employer Group Name results without running another search.',
  },
  {
    target: HOME_TOUR_TARGETS.results,
    title: 'Search results',
    description: 'Review, open, and download the matching RFI records from respective result row.',
    position: 'bottom',
  },
  {
    target: HOME_TOUR_TARGETS.pagination,
    title: 'Pagination',
    description: 'Move between result pages and choose how many records to show.',
  },
  {
    target: HOME_TOUR_TARGETS.download,
    title: 'Download RFI',
    description: 'Download a completed RFI from the Download RFI column.',
  },
] as const;
